import { render, staticRenderFns } from "./settingRecord.vue?vue&type=template&id=7d42972c&scoped=true&"
import script from "./settingRecord.vue?vue&type=script&lang=js&"
export * from "./settingRecord.vue?vue&type=script&lang=js&"
import style0 from "./record.less?vue&type=style&index=0&id=7d42972c&prod&lang=less&scoped=true&"
import style1 from "./settingRecord.vue?vue&type=style&index=1&id=7d42972c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d42972c",
  null
  
)

export default component.exports